import { Summary } from 'model/Summary';
import { Resource } from 'model/Resource';
import { SummaryPulseComparedModel } from 'api/dto/new/SummaryPulseCompared.dto';

export const STORE_NAME = 'summary';

export namespace SummaryState {
  export type Domain = {
    combine: Resource<Summary.Combine>;
    compare: Resource<Summary.Compare[]>;
    pulses: Resource<Summary.Pulses>;
    pulseCompared: Resource<SummaryPulseComparedModel | null>;
  };

  export const INITIAL_DOMAIN_COMBINE = Resource.createPendingResource<Summary.Combine>(
    {} as Summary.Combine
  );

  export const INITIAL_DOMAIN_COMPARE = Resource.createPendingResource<Summary.Compare[]>([]);

  export const INITIAL_DOMAIN_PULSES = Resource.createPendingResource<Summary.Pulses>({
    list: undefined,
  });

  export const INITIAL_DOMAIN_PULSE_COMPARED = Resource.createPendingResource<SummaryPulseComparedModel | null>(
    null
  );

  export const INITIAL_DOMAIN: SummaryState.Domain = {
    combine: INITIAL_DOMAIN_COMBINE,
    compare: INITIAL_DOMAIN_COMPARE,
    pulses: INITIAL_DOMAIN_PULSES,
    pulseCompared: INITIAL_DOMAIN_PULSE_COMPARED,
  };
}

export type SummaryState = {
  summary: SummaryState.Domain;
};
